import React, { useState } from "react";
import { useNavigate } from "react-router";
import {
  VerifiedIcon,
  ModerationIcon,
  PrivacyIcon,
  VisibilityIcon,
  DocumentIcon,
  SelfieIcon,
  HeartSecurityIcon,
} from "@/svgs";
import { AuthModal } from "@/components";
import "./Security.css";

const SecurityScreen: React.FC = () => {
  const navigate = useNavigate();

  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <div className="security-page">
      <section className="security-hero">
        <div className="v2-container">
          <div className="security-hero-content">
            <span className="v2-sub-title">SEGURANÇA E PRIVACIDADE</span>

            <h1>
              Sua segurança <br />
              <span className="v2-gold-text">em primeiro lugar</span>
            </h1>

            <p>
              Criamos um ambiente focado em conexões reais, com verificação
              manual de identidade, moderação ativa e proteção de dados para
              garantir uma experiência mais segura dentro da plataforma.
            </p>

            <div className="security-hero-buttons">
              <button
                className="v2-btn-gold"
                type="button"
                onClick={(e) => {
                  navigate("/verificacao");
                }}
              >
                Saiba mais sobre verificação
              </button>

              <button
                className="v2-btn-outline"
                type="button"
                onClick={(e) => {
                  navigate("/diretrizes");
                }}
              >
                Diretrizes da comunidade
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="security-cards-section">
        <div className="v2-container">
          <div className="security-grid">
            <div className="security-card">
              <VerifiedIcon />

              <h3>Perfis verificados</h3>

              <p>
                Verificação real com selfie e documento oficial para aumentar a
                confiança entre os usuários.
              </p>
            </div>

            <div className="security-card">
              <ModerationIcon />

              <h3>Moderação ativa</h3>

              <p>
                Monitoramento constante de denúncias, atividades suspeitas e
                perfis falsos.
              </p>
            </div>

            <div className="security-card">
              <PrivacyIcon />

              <h3>Proteção de dados</h3>

              <p>
                Seus dados são armazenados com segurança e nunca exibidos
                publicamente.
              </p>
            </div>

            <div className="security-card">
              <VisibilityIcon />

              <h3>Controle de visibilidade</h3>

              <p>
                Você escolhe quem pode visualizar seu perfil e entrar em
                contato.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="security-flow">
        <div className="v2-container">
          <div className="security-flow-header">
            <span className="v2-sub-title">COMO FUNCIONA</span>

            <h2>
              Processo de <span className="v2-gold-text">verificação</span>
            </h2>

            <p>
              Nosso sistema foi criado para reduzir perfis falsos e aumentar a
              autenticidade da plataforma.
            </p>
          </div>

          <div className="security-steps">
            <div className="security-step">
              <div className="security-step-number">01</div>

              <DocumentIcon />

              <h4>Envio do documento</h4>

              <p>
                O usuário envia um documento oficial válido com foto para
                análise.
              </p>
            </div>

            <div className="security-step">
              <div className="security-step-number">02</div>

              <SelfieIcon />

              <h4>Selfie de verificação</h4>

              <p>
                Também solicitamos uma selfie em tempo real para validar a
                identidade.
              </p>
            </div>

            <div className="security-step">
              <div className="security-step-number">03</div>

              <ModerationIcon />

              <h4>Análise manual</h4>

              <p>
                Nossa equipe revisa manualmente as informações enviadas pelo
                usuário.
              </p>
            </div>

            <div className="security-step">
              <div className="security-step-number">04</div>

              <VerifiedIcon />

              <h4>Perfil aprovado</h4>

              <p>
                Após aprovação, o perfil recebe o selo oficial de verificado.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="security-about">
        <div className="v2-container">
          <div className="security-about-box">
            <HeartSecurityIcon />

            <h2>Compromisso com conexões reais</h2>

            <p>
              Acreditamos que confiança é essencial para qualquer conexão. Por
              isso, investimos em ferramentas de segurança, validação de
              identidade e moderação ativa para tornar a experiência dentro da
              plataforma mais segura, transparente e autêntica.
            </p>

            <p>
              Nosso objetivo é reduzir fraudes, impedir contas falsas e criar um
              ambiente onde as pessoas possam interagir com mais tranquilidade e
              segurança.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="security-cta">
        <div className="v2-container">
          <div className="security-cta-content">
            <VerifiedIcon />

            <h2>Mais segurança para conexões verdadeiras</h2>

            <p>
              Trabalhamos constantemente para manter a plataforma segura para
              todos os usuários.
            </p>

            <button
              className="v2-btn-gold"
              type="button"
              onClick={() => setIsAuthModalOpen(true)}
            >
              Solicitar Acesso Exclusivo
            </button>
          </div>
        </div>
      </section>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
};

export default SecurityScreen;
